import React, { useEffect, useId, useRef, useState } from 'react';

export default function GoodsParamSelect({
  value,
  options = [],
  onChange,
  disabled = false,
  className = '',
  variant = 'default',
  ariaLabel,
  open: controlledOpen,
  onOpenChange,
  menuPlacement = 'down',
}) {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;
  const rootRef = useRef(null);
  const listId = useId();
  const selected = options.find((item) => item.value === value) || options[0];

  const setOpen = (next) => {
    if (!isControlled) setInternalOpen(next);
    onOpenChange?.(next);
  };

  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (event) => {
      if (rootRef.current?.contains(event.target)) return;
      setOpen(false);
    };
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const pick = (nextValue) => {
    if (disabled) return;
    onChange?.(nextValue);
    setOpen(false);
  };

  return (
    <div
      ref={rootRef}
      className={`wf-editor-goods__param-select-wrap wf-editor-goods__param-select-wrap--${variant}${open ? ' wf-editor-goods__param-select-wrap--open' : ''}${menuPlacement === 'up' ? ' wf-editor-goods__param-select-wrap--menu-up' : ''}${className ? ` ${className}` : ''}`}
    >
      <button
        type="button"
        className={`wf-editor-goods__param-select-trigger wf-editor-goods__param-select-trigger--${variant}`}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-controls={listId}
        onClick={() => {
          if (disabled) return;
          setOpen(!open);
        }}
      >
        <span className="wf-editor-goods__param-select-text">{selected?.label || '请选择'}</span>
        <span className="wf-editor-goods__param-select-chevron" aria-hidden>
          {open ? '▴' : '▾'}
        </span>
      </button>
      {open ? (
        <ul
          id={listId}
          className="wf-editor-goods__param-select-menu"
          role="listbox"
          aria-label={ariaLabel}
        >
          {options.map((item) => {
            const active = item.value === value;
            return (
              <li key={item.value} role="presentation">
                <button
                  type="button"
                  role="option"
                  aria-selected={active}
                  className={`wf-editor-goods__param-select-option${active ? ' wf-editor-goods__param-select-option--active' : ''}`}
                  onClick={() => pick(item.value)}
                >
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
}
